/**
 * @deprecated
 * Constants string for dataset names used by dark mode
 */
// eslint-disable-next-line etc/no-const-enum
export const enum DarkModeDatasetNames {
    /**
     * Original style text color
     */
    OriginalStyleColor = 'ogsc',

    /**
     * Original style background color
     */
    OriginalStyleBackgroundColor = 'ogsb',

    /**
     * Original attribute text color
     */
    OriginalAttributeColor = 'ogac',

    /**
     * Original attribute background color
     */
    OriginalAttributeBackgroundColor = 'ogab',
}
